module.exports = __webpack_public_path__ + "img/pic_suppay_freecoins.00da351a.png";